import styled from "@emotion/styled/macro";
import Box from "@mui/material/Box";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledKnowledgeBaseModalOption = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderRadius: "4px",
  border: "1px solid #E6E6E6",
  padding: "16px 16px 16px 20px",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  justifyContent: "space-between",
}));
